import { render, staticRenderFns } from "./ReportCardGradingDetail.vue?vue&type=template&id=49ad96d2"
import script from "@/controllers/custom/report_card_grading/report-card-grading-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/report_card_grading/report-card-grading-detail.js?vue&type=script&lang=js&external"
import style0 from "./ReportCardGradingDetail.vue?vue&type=style&index=0&id=49ad96d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports